import { useEffect } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import {
  SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  TRELLO_OPERATIONAL_QUICK_CAPTURE_DISCOVERY_ENABLED_CHANGED,
  TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH,
  TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH,
  useUserTrait,
} from '@trello/atlassian-personalization';
import { useMemberId } from '@trello/authentication';
import { getDateBefore, idToDate } from '@trello/dates';

export const useIsEligibleForQuickCaptureDiscovery = () => {
  const memberId = useMemberId();

  const signedUpMoreThan21DaysAgo =
    idToDate(memberId) < getDateBefore({ days: 21 });

  const {
    value: hasViewedQuickCapture,
    loading: hasViewedQuickCaptureLoading,
  } = useUserTrait(
    SEGMENT_TRELLO_HAS_LEARNED_MORE_INBOX_QUICK_CAPTURE_REAL_TIME_AAID,
  );

  const { value: hasUsedQuickCapture, loading: hasUsedQuickCaptureLoading } =
    useUserTrait(SEGMENT_TRELLO_HAS_USED_INBOX_QUICK_CAPTURE_REAL_TIME_AAID);

  const {
    value: hasUsedQuickCaptureHistorical,
    loading: hasUsedQuickCaptureHistoricalLoading,
  } = useUserTrait(TRELLO_TRACK_CARD_ADDED_QUICK_CAPTURE_CHANGED_BATCH);

  const {
    value: hasViewedQuickCaptureHistorical,
    loading: hasViewedQuickCaptureHistoricalLoading,
  } = useUserTrait(TRELLO_UI_CLICKED_QUICK_CAPTURE_PROMPT_CHANGED_BATCH);

  const { value: hasEnabledQuickCaptureDiscovery } = useUserTrait(
    TRELLO_OPERATIONAL_QUICK_CAPTURE_DISCOVERY_ENABLED_CHANGED,
  );

  const isCriteriaSatisfied =
    signedUpMoreThan21DaysAgo &&
    !hasViewedQuickCaptureLoading &&
    !hasUsedQuickCaptureLoading &&
    !hasUsedQuickCaptureHistoricalLoading &&
    !hasViewedQuickCaptureHistoricalLoading &&
    !(
      hasViewedQuickCapture ||
      hasUsedQuickCapture ||
      hasUsedQuickCaptureHistorical ||
      hasViewedQuickCaptureHistorical
    );

  useEffect(() => {
    if (isCriteriaSatisfied) {
      // TODO go/j/TJC-7271 update source to support any `sourceType`
      Analytics.sendOperationalEvent({
        action: 'enabled',
        actionSubject: 'quickCaptureDiscovery',
        source: 'inboxScreen',
      });
    }
  }, [isCriteriaSatisfied]);

  if (hasEnabledQuickCaptureDiscovery) {
    return true;
  }

  return isCriteriaSatisfied;
};
